/**
 * Cart share button: on mobile opens share drawer; on desktop copies data-url and shows "Link Copied".
 */

export class CartShareButtonElement extends HTMLElement {
  private boundClick = this.handleClick.bind(this)

  connectedCallback() {
    this.addEventListener('click', this.boundClick)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.boundClick)
  }

  private async handleClick(e: Event) {
    e.preventDefault()
    const url = this.getAttribute('data-url') || ''
    if (!url) return

    const showCopied = () => {
      this.innerHTML = 'Link Copied'
      this.classList.add('!text-system-success')
      setTimeout(() => {
        this.innerHTML = 'Share'
        this.classList.remove('!text-system-success')
      }, 5000)
    }

    const copyToClipboard = () => {
      try {
        if (navigator.clipboard?.writeText) {
          navigator.clipboard.writeText(url).then(showCopied)
          return
        }
      } catch {}
      const ta = document.createElement('textarea')
      ta.value = url
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      document.body.appendChild(ta)
      ta.select()
      if (document.execCommand('copy')) showCopied()
      document.body.removeChild(ta)
    }

    if (navigator.share) {
      showCopied()
      copyToClipboard()
      try {
        await navigator.share({
          title: document.title,
          text: 'Here is my current Black Pepper cart',
          url
        })
      } catch {
        // user cancelled or share failed — feedback already shown
      }
    } else {
      copyToClipboard()
    }
  }
}
